import { stringify } from "query-string";
import { useCallback, useMemo, useState } from "react";
import { SiteContryEnum } from "shared/enums/globalEnums";
import { ViewTypeEnum } from "../types";

const BASE_GRAFANA_URL = "https://joulestream.data.nwstorm.io";
const useGrafanaUrl = (country: SiteContryEnum, params: Record<string, string | number>, isSiteView: boolean) => {
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = useCallback(() => setRefreshKey((k: number) => k + 1), []);

  const getCountrySlug = useCallback((c?: SiteContryEnum) => {
    switch (c) {
      case SiteContryEnum.Finland:
        return "de404w8ezefb4c/operations-finlande";
      case SiteContryEnum.France:
      default:
        return "ce1mnuvm20gzka/operations-france";
    }
  }, []);

  const getBaseSrc = useCallback(
    (viewType: ViewTypeEnum, slug: string) => `${BASE_GRAFANA_URL}/${viewType}/${slug}?orgId=1`,
    [],
  );

  const paramsString = useMemo(() => stringify(params), [params]);

  const generateUrl = useCallback(
    (viewType: ViewTypeEnum) => {
      const slug = getCountrySlug(country);
      return `${getBaseSrc(viewType, slug)}&${paramsString}`;
    },
    [country, paramsString, getCountrySlug, getBaseSrc],
  );

  const graphOnlyUrl = useMemo(() => {
    const extraParams = isSiteView
      ? stringify({
          // WARNING: This is a workaround due to grafana graphs being grouped by edr,
          // yet the edr infos are not needed for this specific graph, and it wouldn't
          // work for finland sites
          "var-edr_name": "",
          "var-code_tm": "",
        })
      : "";

    const url = generateUrl(ViewTypeEnum.softval);
    return `${url}&${extraParams}`;
  }, [generateUrl, isSiteView]);

  const grafanaDashboardUrl = useMemo(() => {
    return generateUrl(ViewTypeEnum.grafana);
  }, [generateUrl]);

  return { graphOnlyUrl, grafanaDashboardUrl, handleRefresh, refreshKey };
};

export default useGrafanaUrl;
